import { BellOutlined, CheckCircleFilled, ClockCircleOutlined, ExclamationCircleFilled, MailOutlined, SearchOutlined, StopOutlined } from "@ant-design/icons";
import { message, Modal, Table, Tooltip } from "antd";
import axios from "axios";
import moment from "moment";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ButtonItem, InputItem, SegmentedItem, TableItem, TagItem } from "../../../../Components/Items";
import { colorPaleta } from "../../../../Components/TagItem";
import { KpiRow, STYLES } from "../../../Panel/Calidad/ReporteCalidad/reporteCalidadStyles";
import { formatoDinero, postCobro } from "./cobroBiwoTextos";

const estiloBarra = {
    backgroundColor: "white",
    padding: "12px 20px",
    border: "1px solid rgb(235, 237, 240)",
    borderRadius: 12,
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
    marginBottom: 10,
    display: "flex",
    alignItems: "center",
    gap: 12,
    flexWrap: "wrap",
};

const estiloTarjeta = { backgroundColor: "white", borderRadius: 12, padding: 20, boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)" };

const ATRASOS = [
    { key: "d30", titulo: "1 a 30 días", paleta: "ambar", color: colorPaleta("ambar") },
    { key: "d60", titulo: "31 a 60 días", paleta: "naranja", color: colorPaleta("naranja") },
    { key: "d90", titulo: "61 a 90 días", paleta: "danger", color: colorPaleta("danger") },
    { key: "mas90", titulo: "Más de 90 días", paleta: "vino", color: colorPaleta("vino") },
];

const fecha = (valor) => (valor ? moment(valor).format("DD/MM/YYYY") : "—");
const plural = (n, uno, varios) => `${n} ${n === 1 ? uno : varios}`;

const situacion = (dias, saldo) => {
    if (!(saldo > 0)) return "pagado";
    if (dias <= 0) return "alDia";
    return ATRASOS.find((a) => (a.key === "d30" ? dias <= 30 : a.key === "d60" ? dias <= 60 : a.key === "d90" ? dias <= 90 : true)).key;
};

const FILTROS_SITUACION = [{ text: "Pagado", value: "pagado" }, { text: "Al día", value: "alDia" }, ...ATRASOS.map((a) => ({ text: `Vencido ${a.titulo}`, value: a.key }))];

const Atraso = ({ dias, saldo }) => {
    if (!(saldo > 0)) return <TagItem verdeNatural icon={<CheckCircleFilled />}>Pagado</TagItem>;
    if (dias <= 0) return <TagItem azul icon={<ClockCircleOutlined />}>Al día</TagItem>;
    const atraso = ATRASOS.find((a) => (a.key === "d30" ? dias <= 30 : a.key === "d60" ? dias <= 60 : a.key === "d90" ? dias <= 90 : true));
    return <TagItem {...{ [atraso.paleta]: true }} icon={<ExclamationCircleFilled />}>{`Vencido hace ${plural(dias, "día", "días")}`}</TagItem>;
};

class CobranzaCobro extends Component {
    state = { loading: false, masters: [], texto: "", vista: "conSaldo", enviando: null };

    componentDidMount() {
        this.consultar();
    }

    consultar = () => {
        this.setState({ loading: true });
        postCobro(axios, "selectCobranzaCobro", {}, this.props.headersToken).then((data) => {
            if (data.success === 2) this.setState({ loading: false, masters: data.data.masters });
            else {
                this.setState({ loading: false });
                message.error(data.message || "No se pudo consultar la cobranza");
            }
        });
    };

    enviarRecordatorio = (master) => {
        Modal.confirm({
            title: `Enviar recordatorio a ${master.nombre}`,
            content: `Le llegará por correo el detalle de ${plural(master.remisionesPendientes, "remisión", "remisiones")} por ${formatoDinero(master.saldo)}.`,
            okText: "Enviar",
            cancelText: "Cancelar",
            onOk: () => {
                this.setState({ enviando: master._id });
                return postCobro(axios, "enviarRecordatorioCobranza", { usuarioId: master._id }, this.props.headersToken).then((data) => {
                    this.setState({ enviando: null });
                    if (data.success === 2) {
                        message.success(data.message);
                        this.consultar();
                    } else message.warning(data.message || "No se pudo enviar el recordatorio");
                });
            },
        });
    };

    cambiarRecordatorios = (master) => {
        postCobro(axios, "cambiarRecordatoriosMaster", { usuarioId: master._id, sinRecordatorios: !master.sinRecordatorios }, this.props.headersToken).then((data) => {
            if (data.success === 2) {
                message.success(data.message);
                this.consultar();
            } else message.warning(data.message || "No se pudo guardar");
        });
    };

    renderResumen() {
        const conSaldo = this.state.masters.filter((m) => m.saldo > 0);
        const vencidos = conSaldo.filter((m) => m.vencido > 0);
        const saldo = conSaldo.reduce((s, m) => s + m.saldo, 0);
        const vencido = vencidos.reduce((s, m) => s + m.vencido, 0);
        return (
            <KpiRow
                style={{ marginBottom: 10 }}
                items={[
                    { key: "saldo", label: "Nos deben", value: formatoDinero(saldo), color: colorPaleta("cyan"), span: 8, hint: plural(conSaldo.length, "cliente con saldo", "clientes con saldo") },
                    {
                        key: "vencido",
                        label: "Ya vencido",
                        value: formatoDinero(vencido),
                        color: vencido > 0 ? colorPaleta("danger") : "#1e293b",
                        span: 8,
                        hint: vencido > 0 ? `${plural(vencidos.length, "cliente", "clientes")} con pagos atrasados` : "Nadie tiene pagos atrasados",
                    },
                    { key: "porVencer", label: "Por vencer", value: formatoDinero(saldo - vencido), color: "#1e293b", span: 8, hint: "Remisiones que todavía están en plazo" },
                ]}
            />
        );
    }

    renderAtrasos() {
        const conSaldo = this.state.masters.filter((m) => m.saldo > 0);
        const grupos = ATRASOS.map((a) => ({ ...a, monto: conSaldo.reduce((s, m) => s + (m.rangos[a.key] || 0), 0), clientes: conSaldo.filter((m) => m.rangos[a.key] > 0).length }));
        const total = grupos.reduce((s, g) => s + g.monto, 0);
        if (!total) return null;
        return (
            <div style={{ ...estiloTarjeta, marginBottom: 10 }}>
                <div style={{ fontSize: 14, fontWeight: 600, color: "#1a3a4a", marginBottom: 10 }}>¿Qué tan atrasado está lo vencido?</div>
                <div style={{ display: "flex", gap: 2, height: 14, marginBottom: 12 }}>
                    {grupos.filter((g) => g.monto > 0).map((g) => (
                        <Tooltip key={g.key} title={`${g.titulo}: ${formatoDinero(g.monto)} · ${plural(g.clientes, "cliente", "clientes")}`}>
                            <div style={{ width: `${(g.monto / total) * 100}%`, minWidth: 6, background: g.color, borderRadius: 4 }} />
                        </Tooltip>
                    ))}
                </div>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "8px 28px" }}>
                    {grupos.map((g) => (
                        <div key={g.key} style={{ display: "flex", alignItems: "center", gap: 8, opacity: g.monto > 0 ? 1 : 0.45 }}>
                            <span style={{ width: 10, height: 10, borderRadius: 2, background: g.color, display: "inline-block" }} />
                            <span style={{ color: "#595959" }}>{g.titulo}</span>
                            <b>{formatoDinero(g.monto)}</b>
                            <span style={{ color: "#8c8c8c", fontSize: 12 }}>{g.clientes ? plural(g.clientes, "cliente", "clientes") : ""}</span>
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    renderRemisiones(master) {
        return (
            <Table
                size="small"
                className="custom-small-table"
                scroll={{ x: "max-content" }}
                rowKey="remisionId"
                pagination={false}
                dataSource={master.remisiones}
                columns={[
                    {
                        title: "Remisión",
                        render: (r) => (
                            <>
                                {r.folio}
                                {r.documentos.length > 0 && <div style={{ fontSize: 12, color: "#8c8c8c" }}>Facturada: {r.documentos.join(", ")}</div>}
                            </>
                        ),
                    },
                    { title: "Mes que cubre", sorter: (a, b) => moment(a.periodoInicio || 0).valueOf() - moment(b.periodoInicio || 0).valueOf(), render: (r) => `${fecha(r.periodoInicio)} al ${fecha(r.periodoFin)}` },
                    { title: "Fecha límite de pago", sorter: (a, b) => moment(a.fechaVencimiento || 0).valueOf() - moment(b.fechaVencimiento || 0).valueOf(), render: (r) => fecha(r.fechaVencimiento) },
                    { title: "Total", align: "right", sorter: (a, b) => (a.total || 0) - (b.total || 0), render: (r) => formatoDinero(r.total) },
                    { title: "Pagado", align: "right", sorter: (a, b) => (a.pagado || 0) - (b.pagado || 0), render: (r) => formatoDinero(r.pagado) },
                    { title: "Debe", align: "right", sorter: (a, b) => (a.saldo || 0) - (b.saldo || 0), render: (r) => <b>{formatoDinero(r.saldo)}</b> },
                    { title: "Situación", filters: FILTROS_SITUACION, onFilter: (valor, r) => situacion(r.diasVencido, r.saldo) === valor, render: (r) => <Atraso dias={r.diasVencido} saldo={r.saldo} /> },
                ]}
            />
        );
    }

    render() {
        const { masters, texto, vista } = this.state;
        const regex = texto ? new RegExp(texto.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "i") : null;
        const filtrados = masters
            .filter((m) => (vista === "todos" || m.saldo > 0) && (!regex || regex.test(m.nombre) || regex.test(m.nombreCorporativo)))
            .sort((a, b) => b.diasMaximo - a.diasMaximo || b.saldo - a.saldo);
        return (
            <>
                <style>{STYLES}</style>
                {this.renderResumen()}
                {this.renderAtrasos()}
                <div style={estiloBarra}>
                    <span style={{ fontSize: 15, fontWeight: 600, color: "#1a3a4a" }}>Clientes, del más atrasado al más al día</span>
                    <div style={{ flex: 1 }} />
                    <SegmentedItem
                        value={vista}
                        onChange={(valor) => this.setState({ vista: valor })}
                        options={[{ value: "conSaldo", label: "Con saldo" }, { value: "todos", label: "Todos" }]}
                    />
                    <InputItem
                        prefix={<SearchOutlined />}
                        placeholder="Buscar master o corporativo"
                        allowClear
                        style={{ width: 280, maxWidth: "100%" }}
                        value={texto}
                        onChange={(e) => this.setState({ texto: e.target.value })}
                    />
                </div>
                <div style={estiloTarjeta}>
                    <TableItem
                        size="small"
                        loading={this.state.loading}
                        dataSource={filtrados.map((m) => ({ ...m, clienteTexto: `${m.nombre || ""} ${m.nombreCorporativo || ""}` }))}
                        expandable={{ expandedRowRender: (m) => this.renderRemisiones(m), expandRowByClick: true }}
                        locale={{ emptyText: vista === "conSaldo" ? "Nadie nos debe" : "Todavía no hay remisiones de cobro" }}
                        columns={[
                            {
                                key: "cliente",
                                title: "Cliente (master)",
                                width: "26%",
                                buscar: "clienteTexto",
                                render: (m) => (
                                    <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
                                        <div style={{ fontWeight: 500 }}>{m.nombre}</div>
                                        {m.nombreCorporativo && <div style={{ fontSize: 12, color: "#8c8c8c" }}>{m.nombreCorporativo}</div>}
                                    </div>
                                ),
                            },
                            { key: "saldo", title: "Nos debe", align: "right", width: "12%", sorter: (a, b) => (a.saldo || 0) - (b.saldo || 0), render: (m) => <b>{formatoDinero(m.saldo)}</b> },
                            { key: "vencido", title: "De eso, vencido", align: "right", width: "12%", sorter: (a, b) => (a.vencido || 0) - (b.vencido || 0), render: (m) => (m.vencido > 0 ? <span style={{ color: colorPaleta("danger"), fontWeight: 600 }}>{formatoDinero(m.vencido)}</span> : "—") },
                            { key: "situacion", title: "Situación", width: "17%", filters: FILTROS_SITUACION, onFilter: (valor, m) => situacion(m.diasMaximo, m.saldo) === valor, render: (m) => <Atraso dias={m.diasMaximo} saldo={m.saldo} /> },
                            { key: "pendientes", title: "Remisiones sin pagar", align: "center", width: "10%", sorter: (a, b) => (a.remisionesPendientes || 0) - (b.remisionesPendientes || 0), render: (m) => m.remisionesPendientes || "—" },
                            {
                                key: "recordatorio",
                                title: "Último recordatorio",
                                sorter: (a, b) => moment(a.ultimoRecordatorio || 0).valueOf() - moment(b.ultimoRecordatorio || 0).valueOf(),
                                filters: [{ text: "Automáticos apagados", value: "apagados" }, { text: "Automáticos encendidos", value: "encendidos" }],
                                onFilter: (valor, m) => (m.sinRecordatorios ? "apagados" : "encendidos") === valor,
                                render: (m) => (
                                    <div style={{ whiteSpace: "normal" }}>
                                        {m.ultimoRecordatorio ? fecha(m.ultimoRecordatorio) : "Nunca"}
                                        {m.sinRecordatorios && <div><TagItem naranja style={{ marginTop: 4 }}>Automáticos apagados</TagItem></div>}
                                    </div>
                                ),
                            },
                            {
                                key: "acciones",
                                title: "Acciones",
                                width: 90,
                                align: "center",
                                render: (m) => (
                                    <div style={{ display: "flex", gap: 4, justifyContent: "center" }} onClick={(e) => e.stopPropagation()}>
                                        <Tooltip title="Enviar recordatorio de pago ahora">
                                            <ButtonItem
                                                size="small"
                                                azul
                                                icon={<MailOutlined />}
                                                disabled={!(m.saldo > 0)}
                                                loading={this.state.enviando === m._id}
                                                onClick={() => this.enviarRecordatorio(m)}
                                            />
                                        </Tooltip>
                                        <Tooltip title={m.sinRecordatorios ? "Volver a mandarle recordatorios automáticos" : "Dejar de mandarle recordatorios automáticos"}>
                                            <ButtonItem
                                                size="small"
                                                {...(m.sinRecordatorios ? { verde: true } : { naranja: true })}
                                                icon={m.sinRecordatorios ? <BellOutlined /> : <StopOutlined />}
                                                onClick={() => this.cambiarRecordatorios(m)}
                                            />
                                        </Tooltip>
                                    </div>
                                ),
                            },
                        ]}
                    />
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => ({ headersToken: state.user.headersToken });

export default connect(mapStateToProps)(CobranzaCobro);
